import React from 'react';
import { Trans } from '@lingui/react/macro';
import { BaseProduct, ProfileCatalogProduct, ProjectCatalogProduct, UnitOfMeasurement } from '@/types';

export function convertToUnit(valueInCm: number | null, unit: UnitOfMeasurement) {
    if (!valueInCm) {
        return null;
    }
    switch (unit) {
        case UnitOfMeasurement.Millimeter:
            return valueInCm * 10;
        case UnitOfMeasurement.Centimeter:
        default:
            return valueInCm;
    }
}

export function convertToCentimeter(value: number | null, convertFromUnit: UnitOfMeasurement) {
    if (!value) {
        return null;
    }
    switch (convertFromUnit) {
        case UnitOfMeasurement.Millimeter:
            return value / 10;
        case UnitOfMeasurement.Centimeter:
        default:
            return value;
    }
}
export const unitAbbreviations = {
    [UnitOfMeasurement.Centimeter]: <Trans id="CentimeterAbbreviation">cm</Trans>,
    [UnitOfMeasurement.Millimeter]: <Trans id="MillimeterAbbreviation">mm</Trans>,
};

export interface Measurements {
    width: number | null;
    depth: number | null;
    height: number | null;
    length: number | null;
}
export function getMeasurementsFromProduct(
    product: ProjectCatalogProduct | ProfileCatalogProduct | null,
    unit: UnitOfMeasurement
) {
    return {
        width: convertToUnit(product?.widthCm ?? null, unit),
        depth: convertToUnit(product?.depthCm ?? null, unit),
        height: convertToUnit(product?.heightCm ?? null, unit),
        length: convertToUnit(product?.lengthCm ?? null, unit),
    };
}
export const emptyMeasurement: Measurements = {
    depth: null,
    height: null,
    length: null,
    width: null,
};
export function updateProductFromMeasurements(
    product: BaseProduct,
    measurements: Measurements,
    convertFromUnit: UnitOfMeasurement
) {
    return {
        ...product,
        depthCm: convertToCentimeter(measurements.depth, convertFromUnit),
        widthCm: convertToCentimeter(measurements.width, convertFromUnit),
        heightCm: convertToCentimeter(measurements.height, convertFromUnit),
        lengthCm: convertToCentimeter(measurements.length, convertFromUnit),
    };
}